'use client';
import type { CSSProperties, ReactNode } from 'react';
import { Cbutton } from '../Cbutton';
import { ButtonPreset } from '@/constants/componentPresets';
const BUTTON_SIZE = 32;
const BUTTON_CONTAINER_STYLE: CSSProperties = {
    width: BUTTON_SIZE,
    minWidth: BUTTON_SIZE,
};
const BUTTON_OUTER_STYLE: CSSProperties = {
    width: BUTTON_SIZE,
    flexShrink: 0,
};
export const GRAPH_TOOLBAR_SLIDER_STYLE: CSSProperties = {
    width: 92,
};
export interface GraphToolbarButtonProps {
    onClick: () => void;
    disabled: boolean;
    label: string;
    children: ReactNode;
    style?: CSSProperties;
}
export function GraphToolbarButton({ onClick, disabled, label, children, style, }: GraphToolbarButtonProps) {
    return (
    <Cbutton preset={ButtonPreset.Ghost} radius={6} padding={0} height={BUTTON_SIZE} onClick={onClick} disabled={disabled} containerStyle={BUTTON_CONTAINER_STYLE} style={style ? { ...BUTTON_OUTER_STYLE, ...style } : BUTTON_OUTER_STYLE}>
      <span aria-label={label} title={label} style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
            color: 'rgba(255,255,255,0.76)',
        }}>
        {children}
      </span>
    </Cbutton>
    );
}
